'use client'
import {useTranslations} from 'next-intl';
import {useEffect, useRef, useState} from 'react';
import {useErrorAlert} from '@/hooks/useSweetAlert';
import {confirmResetCodeAction} from '@/actions/auth';
import {getGqlErrorToast} from '@/libs/api/errorHandler';
import LoadSpinner from '@/components/shared/others/LoadSpinner';
import VerificationInput from 'react-verification-input';

export default function ConfirmEmailCodePrimary({ email, setCode, nextTick }) {
  const e = useTranslations('error.message');
  const t = useTranslations('auth');
  
  const [loading, setLoading] = useState(false);
  const toast = useErrorAlert();
  const confirmRef = useRef(null);
  
  useEffect(() => {
    let timer1 = setTimeout(() => confirmRef.current.focus(), 700);
    return () => {
      clearTimeout(timer1);
    };
  }, [email]);
  
  const onConfirm = async (code) => {
    setLoading(true);
    const result = await confirmResetCodeAction({ email, code });
    if (result.error) {
      toast(getGqlErrorToast(result.error.errors, e));
      setLoading(false);
      return;
    }
    if (result.data) {
      setCode(code);
      nextTick();
      setLoading(false);
    }
  };
  
  return (
    <div className="ltn__login-area" style={{minHeight: '70vh', alignContent: 'center'}}>
      <div className="container">
        <div className="section-title-area text-center">
          <h1 className="section-title">
            {t('passwordResetTitle')}
          </h1>
          <p>
            {t.rich('passwordResetDescription', {
              br: () => (<br/>),
              b: (chunks) => (<b>{chunks}</b>),
              email
            })}
          </p>
        </div>
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="account-login-inner">
              <form className="ltn__form-box contact-form-box">
                {loading && <LoadSpinner loading={loading}/>}
                {!loading && (
                    <div className={`verification-field ${loading ? 'd-none' : 'd-block'}`}>
                      <VerificationInput
                          ref={confirmRef}
                          length={6}
                          validChars="0-9"
                          disabled={loading}
                          onComplete={onConfirm}
                          classNames={{
                            character: 'f-character',
                            characterInactive: 'f-character-inactive',
                            characterSelected: 'f-character-selected'
                          }}
                      />
                    </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
